export const documentType = {
  '3ds': (
    <div className='h-[40px] max-h-[40px] w-[40px] min-w-[40px] bg-[url("/icons/document-types/3ds.svg")] bg-cover bg-center bg-no-repeat' />
  ),
  aac: (
    <div className='h-[40px] max-h-[40px] w-[40px] min-w-[40px] bg-[url("/icons/document-types/aac.svg")] bg-cover bg-center bg-no-repeat' />
  ),
  ai: (
    <div className='h-[40px] max-h-[40px] w-[40px] min-w-[40px] bg-[url("/icons/document-types/ai.svg")] bg-cover bg-center bg-no-repeat' />
  ),
  avi: (
    <div className='h-[40px] max-h-[40px] w-[40px] min-w-[40px] bg-[url("/icons/document-types/avi.svg")] bg-cover bg-center bg-no-repeat' />
  ),
  bmp: (
    <div className='h-[40px] max-h-[40px] w-[40px] min-w-[40px] bg-[url("/icons/document-types/bmp.svg")] bg-cover bg-center bg-no-repeat' />
  ),
  cad: (
    <div className='h-[40px] max-h-[40px] w-[40px] min-w-[40px] bg-[url("/icons/document-types/cad.svg")] bg-cover bg-center bg-no-repeat' />
  ),
  cdr: (
    <div className='h-[40px] max-h-[40px] w-[40px] min-w-[40px] bg-[url("/icons/document-types/cdr.svg")] bg-cover bg-center bg-no-repeat' />
  ),
  css: (
    <div className='h-[40px] max-h-[40px] w-[40px] min-w-[40px] bg-[url("/icons/document-types/css.svg")] bg-cover bg-center bg-no-repeat' />
  ),
  dat: (
    <div className='h-[40px] max-h-[40px] w-[40px] min-w-[40px] bg-[url("/icons/document-types/dat.svg")] bg-cover bg-center bg-no-repeat' />
  ),
  dll: (
    <div className='h-[40px] max-h-[40px] w-[40px] min-w-[40px] bg-[url("/icons/document-types/dll.svg")] bg-cover bg-center bg-no-repeat' />
  ),
  dmg: (
    <div className='h-[40px] max-h-[40px] w-[40px] min-w-[40px] bg-[url("/icons/document-types/dmg.svg")] bg-cover bg-center bg-no-repeat' />
  ),
  doc: (
    <div className='h-[40px] max-h-[40px] w-[40px] min-w-[40px] bg-[url("/icons/document-types/doc.svg")] bg-cover bg-center bg-no-repeat' />
  ),
  docx: (
    <div className='h-[40px] max-h-[40px] w-[40px] min-w-[40px] bg-[url("/icons/document-types/doc.svg")] bg-cover bg-center bg-no-repeat' />
  ),
  eps: (
    <div className='h-[40px] max-h-[40px] w-[40px] min-w-[40px] bg-[url("/icons/document-types/eps.svg")] bg-cover bg-center bg-no-repeat' />
  ),
  fla: (
    <div className='h-[40px] max-h-[40px] w-[40px] min-w-[40px] bg-[url("/icons/document-types/fla.svg")] bg-cover bg-center bg-no-repeat' />
  ),
  flv: (
    <div className='h-[40px] max-h-[40px] w-[40px] min-w-[40px] bg-[url("/icons/document-types/flv.svg")] bg-cover bg-center bg-no-repeat' />
  ),
  gif: (
    <div className='h-[40px] max-h-[40px] w-[40px] min-w-[40px] bg-[url("/icons/document-types/gif.svg")] bg-cover bg-center bg-no-repeat' />
  ),
  html: (
    <div className='h-[40px] max-h-[40px] w-[40px] min-w-[40px] bg-[url("/icons/document-types/html.svg")] bg-cover bg-center bg-no-repeat' />
  ),
  indd: (
    <div className='h-[40px] max-h-[40px] w-[40px] min-w-[40px] bg-[url("/icons/document-types/indd.svg")] bg-cover bg-center bg-no-repeat' />
  ),
  iso: (
    <div className='h-[40px] max-h-[40px] w-[40px] min-w-[40px] bg-[url("/icons/document-types/iso.svg")] bg-cover bg-center bg-no-repeat' />
  ),
  jpg: (
    <div className='h-[40px] max-h-[40px] w-[40px] min-w-[40px] bg-[url("/icons/document-types/jpg.svg")] bg-cover bg-center bg-no-repeat' />
  ),
  jpeg: (
    <div className='h-[40px] max-h-[40px] w-[40px] min-w-[40px] bg-[url("/icons/document-types/jpg.svg")] bg-cover bg-center bg-no-repeat' />
  ),
  js: (
    <div className='h-[40px] max-h-[40px] w-[40px] min-w-[40px] bg-[url("/icons/document-types/js.svg")] bg-cover bg-center bg-no-repeat' />
  ),
  midi: (
    <div className='h-[40px] max-h-[40px] w-[40px] min-w-[40px] bg-[url("/icons/document-types/midi.svg")] bg-cover bg-center bg-no-repeat' />
  ),
  mov: (
    <div className='h-[40px] max-h-[40px] w-[40px] min-w-[40px] bg-[url("/icons/document-types/mov.svg")] bg-cover bg-center bg-no-repeat' />
  ),
  mp3: (
    <div className='h-[40px] max-h-[40px] w-[40px] min-w-[40px] bg-[url("/icons/document-types/mp3.svg")] bg-cover bg-center bg-no-repeat' />
  ),
  mpg: (
    <div className='h-[40px] max-h-[40px] w-[40px] min-w-[40px] bg-[url("/icons/document-types/mpg.svg")] bg-cover bg-center bg-no-repeat' />
  ),
  pdf: (
    <div className='h-[40px] max-h-[40px] w-[40px] min-w-[40px] bg-[url("/icons/document-types/pdf.svg")] bg-cover bg-center bg-no-repeat' />
  ),
  php: (
    <div className='h-[40px] max-h-[40px] w-[40px] min-w-[40px] bg-[url("/icons/document-types/php.svg")] bg-cover bg-center bg-no-repeat' />
  ),
  png: (
    <div className='h-[40px] max-h-[40px] w-[40px] min-w-[40px] bg-[url("/icons/document-types/png.svg")] bg-cover bg-center bg-no-repeat' />
  ),
  ppt: (
    <div className='h-[40px] max-h-[40px] w-[40px] min-w-[40px] bg-[url("/icons/document-types/ppt.svg")] bg-cover bg-center bg-no-repeat' />
  ),
  ps: (
    <div className='h-[40px] max-h-[40px] w-[40px] min-w-[40px] bg-[url("/icons/document-types/ps.svg")] bg-cover bg-center bg-no-repeat' />
  ),
  psd: (
    <div className='h-[40px] max-h-[40px] w-[40px] min-w-[40px] bg-[url("/icons/document-types/psd.svg")] bg-cover bg-center bg-no-repeat' />
  ),
  raw: (
    <div className='h-[40px] max-h-[40px] w-[40px] min-w-[40px] bg-[url("/icons/document-types/raw.svg")] bg-cover bg-center bg-no-repeat' />
  ),
  sql: (
    <div className='h-[40px] max-h-[40px] w-[40px] min-w-[40px] bg-[url("/icons/document-types/sql.svg")] bg-cover bg-center bg-no-repeat' />
  ),
  svg: (
    <div className='h-[40px] max-h-[40px] w-[40px] min-w-[40px] bg-[url("/icons/document-types/svg.svg")] bg-cover bg-center bg-no-repeat' />
  ),
  tif: (
    <div className='h-[40px] max-h-[40px] w-[40px] min-w-[40px] bg-[url("/icons/document-types/tif.svg")] bg-cover bg-center bg-no-repeat' />
  ),
  txt: (
    <div className='h-[40px] max-h-[40px] w-[40px] min-w-[40px] bg-[url("/icons/document-types/txt.svg")] bg-cover bg-center bg-no-repeat' />
  ),
  wmv: (
    <div className='h-[40px] max-h-[40px] w-[40px] min-w-[40px] bg-[url("/icons/document-types/wmv.svg")] bg-cover bg-center bg-no-repeat' />
  ),
  xls: (
    <div className='h-[40px] max-h-[40px] w-[40px] min-w-[40px] bg-[url("/icons/document-types/xls.svg")] bg-cover bg-center bg-no-repeat' />
  ),
  xlsx: (
    <div className='h-[40px] max-h-[40px] w-[40px] min-w-[40px] bg-[url("/icons/document-types/xls.svg")] bg-cover bg-center bg-no-repeat' />
  ),
  xml: (
    <div className='h-[40px] max-h-[40px] w-[40px] min-w-[40px] bg-[url("/icons/document-types/xml.svg")] bg-cover bg-center bg-no-repeat' />
  ),
  zip: (
    <div className='h-[40px] max-h-[40px] w-[40px] min-w-[40px] bg-[url("/icons/document-types/zip.svg")] bg-cover bg-center bg-no-repeat' />
  ),
  jfif: (
    <div className='h-[40px] max-h-[40px] w-[40px] min-w-[40px] bg-[url("/icons/document-types/jfif.svg")] bg-cover bg-center bg-no-repeat' />
  ),
  mp4: (
    <div className='h-[40px] max-h-[40px] w-[40px] min-w-[40px] bg-[url("/icons/document-types/mp4.svg")] bg-cover bg-center bg-no-repeat' />
  ),
};
